import { Form } from "react-bootstrap";
import Constants from "../../../Variables/Constants";

export const SizeTabContent = ({
  sizeData,
  selectedSize,
  setSelectedSize,
  fabricData,
  captureSnapshot,
  selectedFabric2Data,
  setSelectedFabric2Data,
  fabric2Id,
}) => {
  if (!sizeData || sizeData.length === 0) {
    return (
      <div
        style={{
          backgroundColor: "#E8E9ED",
          borderRadius: "10px",
        }}
        className="p-3"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
            fontWeight: "600",
            height: "100px",
          }}
        >
          No Sizes Available
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#E8E9ED",
        borderRadius: "10px",
      }}
      className="p-3"
    >
      <Form.Label
        style={{
          fontSize: "20px",
          fontWeight: "500",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        Choose Your Bag Size:
      </Form.Label>
      <div className="row g-4">
        {sizeData.map((item, index) => {
          const isSelected = selectedSize && selectedSize._id === item._id;
          return (
            <div key={index} className="col-12 col-md-4 col-lg-6 col-xl-6">
              <div
                className="min-w-100 sizeh shadow-cc"
                style={{
                  padding: "20px",
                  margin: "10px",
                  backgroundColor: isSelected ? "#1C274C" : "#ffffff",
                  borderRadius: "10px",
                  cursor: "pointer",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
                onClick={() => {
                  const sizeDetail = fabricData?.size_details?.find(
                    (io) => io && io.size_id === item._id
                  );
                  setSelectedSize({
                    ...item,
                    price: sizeDetail?.price,
                    accent_price: sizeDetail?.accent_price || 0,
                  });
                  
                  // Update accent fabric price if accent color is selected
                  if (fabric2Id && selectedFabric2Data) {
                    // Priority: 1. Individual fabric size_details, 2. Fabric type size_details
                    let accentPrice = 0;
                    
                    // First check individual fabric's size_details
                    if (selectedFabric2Data?.size_details) {
                      const accentSizeDetail = selectedFabric2Data.size_details.find(
                        (detail) => detail.size_id === item._id
                      );
                      accentPrice = accentSizeDetail?.accent_price || 0;
                    }
                    
                    // If not found or 0, check fabric_type's size_details
                    if (accentPrice === 0 && selectedFabric2Data?.fabric_type?.size_details) {
                      const fabricTypeSizeDetail = selectedFabric2Data.fabric_type.size_details.find(
                        (detail) => detail.size_id === item._id
                      );
                      accentPrice = fabricTypeSizeDetail?.accent_price || 0;
                    }
                    
                    setSelectedFabric2Data({
                      ...selectedFabric2Data,
                      selected_accent_price: accentPrice,
                    });
                  }
                  
                  captureSnapshot();
                }}
              >
                {item?.image && (
                  <div
                    style={{
                      textAlign: "center",
                      width: "100px",
                      height: "100px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    <img
                      src={`${Constants.imgDomain}${item.image}`}
                      alt={item?.size_name}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                )}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: "14px",
                      color: isSelected ? "#ffffff" : "#000000",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    {item?.size_name} ({item?.size_code}{" "}
                    {item?.dimensions?.width}" X {item?.dimensions?.height}")
                  </div>
                  <div
                    style={{
                      color: isSelected ? "#D9D9D9" : "#8a8a8a",
                      fontSize: "15px",
                      fontWeight: "600",
                    }}
                  >
                    $
                    {
                      fabricData?.size_details?.find(
                        (io) => io && io.size_id === item._id
                      )?.price
                    }
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
